import { ShieldCheck, Briefcase, Star } from "lucide-react";

/**
 * Trust-signal caption shown under every service card.
 *
 * Props: `stats` = { pros_count, jobs_completed, avg_rating, rated_count }.
 *   • Hides fields that are zero so new categories don't scream "empty".
 *   • Falls back to "Pro network growing" when there's nothing to show yet.
 */
export default function CategoryTrustCaption({ stats, className = "" }) {
    const pros = Number(stats?.pros_count || 0);
    const jobs = Number(stats?.jobs_completed || 0);
    const rating = Number(stats?.avg_rating || 0);
    const rated = Number(stats?.rated_count || 0);

    if (!pros && !jobs && !rating) {
        return (
            <div
                data-testid="trust-caption-empty"
                className={`text-[10px] uppercase tracking-[0.22em] text-muted-foreground ${className}`}
            >
                Pro network growing — be an early customer
            </div>
        );
    }

    return (
        <div
            data-testid="trust-caption"
            className={`flex flex-wrap items-center gap-x-3 gap-y-1 text-[10px] uppercase tracking-[0.22em] text-muted-foreground ${className}`}
        >
            {pros > 0 && (
                <span className="inline-flex items-center gap-1" data-testid="trust-pros">
                    <ShieldCheck size={10} className="text-[#FFD700]" />
                    <span className="text-foreground">{pros}</span> verified pros
                </span>
            )}
            {jobs > 0 && (
                <span className="inline-flex items-center gap-1" data-testid="trust-jobs">
                    <Briefcase size={10} className="text-[#FFD700]" />
                    <span className="text-foreground">{jobs.toLocaleString()}</span> jobs
                </span>
            )}
            {rating > 0 && rated > 0 && (
                <span className="inline-flex items-center gap-1" data-testid="trust-rating">
                    <Star size={10} className="text-[#FFD700]" fill="#FFD700" />
                    <span className="text-foreground">{rating.toFixed(1)}</span>
                    <span className="normal-case tracking-normal text-[9px] text-muted-foreground">
                        ({rated})
                    </span>
                </span>
            )}
        </div>
    );
}
